<template>
  <view-resolver>
    <template v-slot:adminView>
      <incident-system-search />
    </template>
    <template v-slot:clientView>
      <incident-system-search-client />
    </template>
  </view-resolver>
</template>
<script>
import { SET_TITLE } from '@/store/mutations';
import ViewResolver from '@/components/ViewResolver';
import IncidentSystemSearch from './IncidentSystemSearch';
import IncidentSystemSearchClient from './IncidentSystemSearchClient';

export default {
  name: 'IncidentSystemSearchViewResolver',
  components: {
    ViewResolver,
    IncidentSystemSearch,
    IncidentSystemSearchClient,
  },
  mounted() {
    this.$store.commit(SET_TITLE, 'Incident System Search');
  },
};
</script>
